import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachLopApi } from "../../../api/ke-hoach/keHoachLopApi";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { keHoachMonChiTietApi } from "../../../api/ke-hoach/keHoachMonChiTietApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachLopSelectRequest";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonChiTietSaveRequest } from "../../../model/request/ke-hoach/IKeHoachMonChiTietSaveRequest";
import { IKeHoachMonCopyRequest } from "../../../model/request/ke-hoach/IKeHoachMonCopyRequest";
import { IKeHoachMonSelectByLopsRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectByLopsRequest";
import { IKeHoachMonSelectByNhomLopRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectByNhomLopRequest";
import { IKeHoachMonUpdateGiaiDoanRequest } from "../../../model/request/ke-hoach/IKeHoachMonUpdateGiaiDoanRequest";
import { IKeHoachMonSelectByLopRequest } from "../../../model/request/ke-hoach/KeHoachMonSelectByLopRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachMonNhomLopFull } from "../../../model/respone/ke-hoach/IKeHoachMonNhomLopFull";
import { eKeHoachMonActionIds, IKeHoachMonActionTypes } from "../../action-types/ke-hoach/IKeHoachMonActions";
import { rootActions } from "../../actions/rootActions";

export function* keHoachMonSaga(): any {
    yield takeEvery(eKeHoachMonActionIds.KE_HOACH_LOP_LOAD_START, loadKeHoachLopWorker);
    yield takeEvery(eKeHoachMonActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachMonActionIds.LOAD_NHOMLOP_FULL_START, loadByNhomLopFullWorker);
    yield takeEvery(eKeHoachMonActionIds.ADDING_MONHOC_START, addMonHocWorker);
    yield takeEvery(eKeHoachMonActionIds.LOAD_CHITIET_START, loadChiTietWorker);
    yield takeEvery(eKeHoachMonActionIds.SAVE_CHITIET_START, saveChiTietWorker);
    yield takeEvery(eKeHoachMonActionIds.DELETE_CHITIET_START, deleteChiTietWorker);
    yield takeEvery(eKeHoachMonActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eKeHoachMonActionIds.UPDATE_GIAI_DOAN_START, updateGiaiDoanWorker);
    yield takeEvery(eKeHoachMonActionIds.COPY_START, copyWorker);
}


function* loadKeHoachLopWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachLopApi.Select, action.payload as IKeHoachLopSelectRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.KE_HOACH_LOP_LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.KE_HOACH_LOP_LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* loadWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.SelectByLops, action.payload as IKeHoachMonSelectByLopsRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

// Gộp: 1 API trả về cả kế hoạch môn + chi tiết phân tiết tuần.
// Put 2 success action có sẵn -> reducer không cần thay đổi.
function* loadByNhomLopFullWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.SelectByNhomLopFull, action.payload as IKeHoachMonSelectByNhomLopRequest);
    if (res.is_success) {
        const data = res.data as IKeHoachMonNhomLopFull;
        yield put(rootActions.keHoach.keHoachMon.LOAD_SUCCESS(data?.keHoachMons ?? []));
        yield put(rootActions.keHoach.keHoachMon.LOAD_CHITIET_SUCCESS(data?.keHoachMonChiTiets ?? []));
    } else {
        yield put(rootActions.keHoach.keHoachMon.LOAD_ERRR(res.message ?? "Có lỗi"));
        yield put(rootActions.keHoach.keHoachMon.LOAD_CHITIET_ERROR(res.message ?? "Có lỗi"));
    }
}

function* addMonHocWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.AddMonHoc, action.payload as IKeHoachMonAddRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.ADDING_MONHOC_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.ADDING_MONHOC_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* loadChiTietWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonChiTietApi.Select, action.payload as IKeHoachMonSelectByLopRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.LOAD_CHITIET_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.LOAD_CHITIET_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* saveChiTietWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonChiTietApi.Saves, action.payload as IKeHoachMonChiTietSaveRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.SAVE_CHITIET_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.SAVE_CHITIET_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteChiTietWorker(action: IKeHoachMonActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonChiTietApi.Deletes, action.payload as IIdsRequest);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.DELETE_CHITIET_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.DELETE_CHITIET_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteWorker(action: IKeHoachMonActionTypes): any {
    const ids = action.payload as number[]
    const res: IBaseRespone = yield call(keHoachMonApi.Deletes, { ids });
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.DELETE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.DELETE_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* updateGiaiDoanWorker(action: IKeHoachMonActionTypes): any {
    const request = action.payload as IKeHoachMonUpdateGiaiDoanRequest
    const res: IBaseRespone = yield call(keHoachMonApi.UpdateGiaiDoan, request);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.UPDATE_GIAI_DOAN_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.UPDATE_GIAI_DOAN_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* copyWorker(action: IKeHoachMonActionTypes): any {
    const request = action.payload as IKeHoachMonCopyRequest
    const res: IBaseRespone = yield call(keHoachMonApi.CopyKeHoach, request);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachMon.COPY_SUCCESS(undefined));
    } else {
        yield put(
            rootActions.keHoach.keHoachMon.COPY_ERROR(res.message ?? "Có lỗi")
        );
    }
}